import { BoomGateAlertOutlineIcon } from './BoomGateAlertOutlineIcon';

/**
 * author: Michael Richins
 * id B138EF8B-B8ED-4792-9967-D4FB4C8E8A98
 * name boom-gate-alert-outline
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/boom-gate-alert-outline.svg
 * tags
 * - Alert / Error 
 * - Transportation + Road 
 */
export const AutomaticGateAlertOutlineIcon = BoomGateAlertOutlineIcon;
export default AutomaticGateAlertOutlineIcon